export default function ResearchHero() {
  return (
    <section className="pt-32 pb-16 bg-gradient-to-br from-brand-50 via-white to-accent-50">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="inline-block px-4 py-1.5 bg-brand-50 border border-brand-100 rounded-full mb-6">
            <span className="text-xs font-semibold text-brand-600 tracking-widest font-heading">
              SCIENCE & RESEARCH
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight mb-6 font-heading">
            Advancing Understanding<br className="hidden md:block" /> of CSCF
          </h1>
          <p className="text-lg text-gray-500 leading-relaxed font-body max-w-2xl">
            Cardiospondylocarpofacial syndrome is one of the rarest genetic conditions known. Every study, every case report, and every family who shares their story moves the science forward.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 mt-8 flex-wrap">
            <a
              href="/science"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-brand-500 text-white font-semibold rounded-full hover:bg-brand-600 transition-colors whitespace-nowrap cursor-pointer font-body"
            >
              <i className="ri-microscope-line"></i>
              View Published Research
            </a>
            <a
              href="#featured-study"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-amber-50 border-2 border-amber-200 text-amber-700 font-semibold rounded-full hover:bg-amber-100 hover:border-amber-400 transition-colors whitespace-nowrap cursor-pointer font-body"
            >
              <i className="ri-star-fill text-amber-500"></i>
              Featured Study
            </a>
            <a
              href="#contact-researchers"
              className="inline-flex items-center gap-2 px-7 py-3.5 border-2 border-gray-200 text-gray-700 font-semibold rounded-full hover:border-brand-300 hover:text-brand-600 transition-colors whitespace-nowrap cursor-pointer font-body"
            >
              <i className="ri-mail-send-line"></i>
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
